import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { apiFetch } from '../lib/api'

const SOCIAL_LINKS = [
  { name: 'Instagram', url: 'https://instagram.com/coeaterapp', icon: 'instagram' },
  { name: 'X (Twitter)', url: 'https://x.com/coeaterapp', icon: 'x' },
  { name: 'Facebook', url: 'https://www.facebook.com/people/CoEater/61591715342745/', icon: 'facebook' },
  { name: 'LinkedIn', url: 'https://linkedin.com/company/coeater', icon: 'linkedin' },
  { name: 'YouTube', url: 'https://youtube.com/@coeaterapp', icon: 'youtube' },
]

function SocialIcon({ icon, className }) {
  switch (icon) {
    case 'instagram':
      return (
        <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
          <path d="M12 2.2c3.2 0 3.6 0 4.9.07 1.2.06 2.2.27 2.9.6.7.3 1.3.7 1.9 1.3.6.6 1 1.2 1.3 1.9.3.7.5 1.7.6 2.9.07 1.3.07 1.7.07 4.9s0 3.6-.07 4.9c-.06 1.2-.27 2.2-.6 2.9-.3.7-.7 1.3-1.3 1.9-.6.6-1.2 1-1.9 1.3-.7.3-1.7.5-2.9.6-1.3.07-1.7.07-4.9.07s-3.6 0-4.9-.07c-1.2-.06-2.2-.27-2.9-.6-.7-.3-1.3-.7-1.9-1.3-.6-.6-1-1.2-1.3-1.9-.3-.7-.5-1.7-.6-2.9C2.2 15.6 2.2 15.2 2.2 12s0-3.6.07-4.9c.06-1.2.27-2.2.6-2.9.3-.7.7-1.3 1.3-1.9.6-.6 1.2-1 1.9-1.3.7-.3 1.7-.5 2.9-.6C8.4 2.2 8.8 2.2 12 2.2zm0 1.8c-3.15 0-3.5 0-4.75.07-1 .05-1.6.2-2 .35-.5.2-.85.42-1.23.8-.38.38-.6.73-.8 1.23-.15.4-.3 1-.35 2C2.8 8.5 2.8 8.85 2.8 12s0 3.5.07 4.75c.05 1 .2 1.6.35 2 .2.5.42.85.8 1.23.38.38.73.6 1.23.8.4.15 1 .3 2 .35 1.25.07 1.6.07 4.75.07s3.5 0 4.75-.07c1-.05 1.6-.2 2-.35.5-.2.85-.42 1.23-.8.38-.38.6-.73.8-1.23.15-.4.3-1 .35-2 .07-1.25.07-1.6.07-4.75s0-3.5-.07-4.75c-.05-1-.2-1.6-.35-2-.2-.5-.42-.85-.8-1.23a3.3 3.3 0 00-1.23-.8c-.4-.15-1-.3-2-.35C15.5 4 15.15 4 12 4zm0 3.4a4.6 4.6 0 110 9.2 4.6 4.6 0 010-9.2zm0 1.8a2.8 2.8 0 100 5.6 2.8 2.8 0 000-5.6zm4.8-2a1.08 1.08 0 110 2.15 1.08 1.08 0 010-2.15z" />
        </svg>
      )
    case 'x':
      return (
        <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
          <path d="M18.9 2H22l-7.6 8.68L23 22h-6.9l-5.4-6.7L4.5 22H1.4l8.1-9.28L1 2h7.1l4.9 6.13L18.9 2zm-1.2 18h1.7L7.4 4H5.6l12.1 16z" />
        </svg>
      )
    case 'facebook':
      return (
        <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
          <path d="M13.5 22v-8.4h2.8l.4-3.3h-3.2V8.1c0-.95.26-1.6 1.63-1.6h1.74V3.5c-.3-.04-1.33-.13-2.53-.13-2.5 0-4.22 1.53-4.22 4.34v2.42H7.3v3.3h2.85V22h3.35z" />
        </svg>
      )
    case 'linkedin':
      return (
        <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
          <path d="M4.98 3.5a2.5 2.5 0 100 5 2.5 2.5 0 000-5zM3.2 8.98h3.56V21H3.2V8.98zm6.32 0h3.42v1.64h.05c.48-.9 1.64-1.86 3.38-1.86 3.61 0 4.28 2.38 4.28 5.47V21h-3.56v-5.47c0-1.3-.02-2.98-1.82-2.98-1.82 0-2.1 1.42-2.1 2.88V21H9.52V8.98z" />
        </svg>
      )
    case 'youtube':
      return (
        <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
          <path d="M21.6 7.2s-.2-1.5-.8-2.16c-.8-.83-1.68-.84-2.1-.89C15.7 4 12 4 12 4h-.01s-3.7 0-6.7.15c-.42.05-1.3.06-2.1.89-.6.66-.8 2.16-.8 2.16S2.2 9 2.2 10.8v1.4c0 1.8.2 3.6.2 3.6s.2 1.5.8 2.16c.8.83 1.85.8 2.32.9 1.68.16 6.48.2 6.48.2s3.7-.01 6.7-.16c.42-.05 1.3-.06 2.1-.89.6-.66.8-2.16.8-2.16s.2-1.8.2-3.6v-1.4c0-1.8-.2-3.6-.2-3.6zM9.9 14.98V8.98l5.6 3-5.6 3z" />
        </svg>
      )
    default:
      return null
  }
}

const SCHEMA_ORG = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebApplication',
      '@id': 'https://coeater.com/#webapp',
      name: 'CoEater',
      url: 'https://coeater.com',
      description:
        'CoEater is a social dining platform that connects people who want to share a meal. Discover nearby meal partners, filter by dietary preference, schedule meetups, and enjoy food together.',
      applicationCategory: 'SocialNetworkingApplication',
      operatingSystem: 'Web',
      offers: { '@type': 'Offer', price: '0', priceCurrency: 'INR' },
      author: { '@type': 'Organization', name: 'CoEater', url: 'https://coeater.com' },
    },
    {
      '@type': 'Organization',
      '@id': 'https://coeater.com/#org',
      name: 'CoEater',
      url: 'https://coeater.com',
      logo: 'https://coeater.com/icon-192.png',
      description: 'Connecting people over food — find a meal buddy near you.',
      legalName: 'Ikash Private Limited',
      brand: {
        '@type': 'Brand',
        name: 'CoEater',
        description: 'CoEater is a registered trademark of Ikash Private Limited.',
      },
      sameAs: SOCIAL_LINKS.map(link => link.url),
    },
    {
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: 'What is CoEater?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'CoEater is a free social dining app that helps you find people nearby who want to share a meal — whether it\'s lunch at a restaurant, a home-cooked dinner, or a quick coffee.',
          },
        },
        {
          '@type': 'Question',
          name: 'Is CoEater free to use?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Yes, CoEater is completely free. Create a profile, set your availability, and start connecting with meal partners in your city today.',
          },
        },
        {
          '@type': 'Question',
          name: 'How do I find a meal partner on CoEater?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Sign up, complete your profile with your dietary preference and city, mark yourself as available, and browse the Discover feed. Send a meal invite to anyone you\'d like to eat with.',
          },
        },
      ],
    },
  ],
}

const FEATURES = [
  {
    icon: '🔍',
    title: 'Discover Meal Partners',
    desc: 'Browse a live feed of people in your city who are open to sharing a meal. Filter by dietary preference, location, or availability.',
  },
  {
    icon: '📬',
    title: 'Send & Receive Invites',
    desc: 'Send a co-eating invite with a proposed meal time. Accept invites from others and confirm your next shared dining experience.',
  },
  {
    icon: '💬',
    title: 'Real-Time Chat',
    desc: 'Once an invite is accepted, chat directly with your meal partner to decide the venue, time, and anything else.',
  },
  {
    icon: '📅',
    title: 'Availability Scheduling',
    desc: 'Set a custom availability label — "Free for lunch today" or "Looking for dinner this weekend" — so others know when to invite you.',
  },
  {
    icon: '📍',
    title: 'Nearby Spots',
    desc: 'Discover restaurants, cafés, and eateries close to you. Pick the perfect spot for your next shared meal.',
  },
  {
    icon: '⭐',
    title: 'Ratings & Trust',
    desc: 'After every meetup, leave a rating and review. Build a reputation as a great dining companion.',
  },
]

const STEPS = [
  { num: '01', title: 'Create Your Profile', desc: 'Sign up with Google, choose your dietary type (Veg, Non-Veg, Vegan, Jain…), set your city, and upload a photo.' },
  { num: '02', title: 'Mark Yourself Available', desc: 'Toggle your availability and add a note like "Free for lunch near Koramangala". Now you appear in others\' Discover feeds.' },
  { num: '03', title: 'Discover & Invite', desc: 'Browse profiles, see who\'s nearby and available, and send a meal invite with a suggested time.' },
  { num: '04', title: 'Chat & Meet', desc: 'Once accepted, use the built-in chat to finalise the details. Go enjoy a great meal together!' },
]

export default function About() {
  const [blogs, setBlogs] = useState([])

  useEffect(() => {
    document.title = 'About CoEater — Find a Meal Partner Near You'
    const metaDesc = document.querySelector('meta[name="description"]')
    if (metaDesc) {
      metaDesc.setAttribute(
        'content',
        'CoEater connects people who want to share a meal. Discover dining partners near you, filter by diet, schedule meetups, and enjoy food together. Free to use.',
      )
    }
  }, [])

  useEffect(() => {
    let mounted = true
    async function loadBlogs() {
      try {
        const res = await apiFetch('/blogs?limit=3')
        if (!res.ok) return
        const data = await res.json()
        if (mounted) setBlogs(data)
      } catch {
        // non-critical on marketing page
      }
    }
    loadBlogs()
    return () => { mounted = false }
  }, [])

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-amber-50 to-yellow-50 px-4 py-6 sm:px-8">
    <article className="max-w-4xl mx-auto w-full" itemScope itemType="https://schema.org/WebApplication">
      {/* JSON-LD Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(SCHEMA_ORG) }}
      />

      {/* ── Hero ── */}
      <header className="text-center py-10 px-4">
        <p className="inline-block rounded-full bg-orange-100 text-orange-600 text-xs font-semibold px-4 py-1.5 mb-4 tracking-wide uppercase">
          Social Dining Platform
        </p>
        <h1
          className="title-font text-4xl sm:text-5xl font-extrabold text-gray-900 leading-tight mb-4"
          itemProp="name"
        >
          Eat Together. <span className="text-orange-500">Connect Better.</span>
        </h1>
        <p
          className="text-lg sm:text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed"
          itemProp="description"
        >
          CoEater is a free social dining app that helps you find people nearby who share your love
          of food — and your meal schedule. Whether it&rsquo;s a solo lunch that&rsquo;d be better shared,
          or a weekend dinner with a new friend, we&rsquo;ve got you covered.
        </p>
        <div className="flex flex-wrap gap-3 justify-center mt-6">
          <a
            href="/"
            className="rounded-2xl bg-gradient-to-r from-red-500 to-orange-500 px-6 py-3 text-sm font-bold text-white shadow-lg hover:from-red-600 hover:to-orange-600 transition"
          >
            🍽️ Find a Meal Partner
          </a>
          <a
            href="/"
            className="rounded-2xl border border-orange-300 bg-white px-6 py-3 text-sm font-bold text-orange-600 hover:bg-orange-50 transition"
          >
            📅 Set My Availability
          </a>
        </div>
      </header>

      {/* ── What is CoEater ── */}
      <section className="bg-white/70 rounded-3xl p-6 sm:p-8 mb-8 shadow-sm border border-orange-100">
        <h2 className="title-font text-2xl font-bold text-gray-900 mb-4">What is CoEater?</h2>
        <p className="text-gray-700 leading-relaxed mb-4">
          <strong>CoEater</strong> is a platform designed for people who believe that food tastes better
          when shared. Millions of people eat alone every day — not by choice, but simply because they
          don&rsquo;t know anyone available at the same time, in the same area, craving the same kind of meal.
        </p>
        <p className="text-gray-700 leading-relaxed mb-4">
          We solve that problem. Create a profile, mark when you&rsquo;re free to eat, and instantly see
          others nearby who are also looking for a meal companion. Filter by dietary preference (Vegetarian,
          Vegan, Non-Veg, Jain, and more), city, or availability window. Send an invite, get chatting, and
          head out to eat together.
        </p>
        <p className="text-gray-700 leading-relaxed">
          CoEater is <strong>100% free</strong>. No subscriptions, no hidden charges — just good food and
          better company.
        </p>
      </section>

      {/* ── How it Works ── */}
      <section className="mb-8">
        <h2 className="title-font text-2xl font-bold text-gray-900 mb-6 text-center">How It Works</h2>
        <ol className="grid sm:grid-cols-2 gap-4" role="list">
          {STEPS.map(step => (
            <li
              key={step.num}
              className="bg-white/70 rounded-2xl p-5 border border-orange-100 shadow-sm flex gap-4"
            >
              <span className="title-font text-3xl font-extrabold text-orange-200 shrink-0 leading-none">
                {step.num}
              </span>
              <div>
                <h3 className="font-bold text-gray-900 mb-1">{step.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{step.desc}</p>
              </div>
            </li>
          ))}
        </ol>
      </section>

      {/* ── Features ── */}
      <section className="mb-8">
        <h2 className="title-font text-2xl font-bold text-gray-900 mb-6 text-center">Key Features</h2>
        <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" role="list">
          {FEATURES.map(f => (
            <li
              key={f.title}
              className="bg-white/70 rounded-2xl p-5 border border-orange-100 shadow-sm"
            >
              <span className="text-2xl mb-3 block">{f.icon}</span>
              <h3 className="font-bold text-gray-900 mb-1 text-sm">{f.title}</h3>
              <p className="text-xs text-gray-600 leading-relaxed">{f.desc}</p>
            </li>
          ))}
        </ul>
      </section>

      {/* ── Blogs ── */}
      <section className="mb-8">
        <h2 className="title-font text-2xl font-bold text-gray-900 mb-6 text-center">Latest From Our Blog</h2>
        {blogs.length === 0 ? (
          <div className="rounded-3xl border border-orange-100 bg-white/70 p-6 text-center text-sm text-gray-600">
            Fresh stories and food tips are coming soon.
          </div>
        ) : (
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {blogs.map(blog => (
            <Link key={blog.id} to={`/blogs/${blog.slug}`} className="overflow-hidden rounded-2xl border border-orange-100 bg-white/80 shadow-sm transition hover:-translate-y-0.5 hover:shadow-md">
                {blog.imageUrl && (
                  <img src={blog.imageUrl} alt={blog.title} className="h-40 w-full object-cover" />
                )}
                <div className="p-4">
                  <h3 className="text-base font-bold text-gray-900 line-clamp-2">{blog.title}</h3>
                  {blog.excerpt && <p className="mt-2 text-sm text-gray-600 line-clamp-3">{blog.excerpt}</p>}
                  <p className="mt-3 text-xs text-gray-500">
                    {blog.author || 'CoEater Team'}
                    {' · '}
                    {blog.publishedAt ? new Date(blog.publishedAt).toLocaleDateString() : new Date(blog.createdAt).toLocaleDateString()}
                  </p>
                </div>
            </Link>
            ))}
          </div>
        )}
        <div className="mt-4 text-center">
          <Link to="/blogs" className="text-sm font-semibold text-orange-600 hover:text-orange-700">
          View all blogs
          </Link>
        </div>
      </section>

      {/* ── FAQ ── */}
      <section className="bg-white/70 rounded-3xl p-6 sm:p-8 mb-8 shadow-sm border border-orange-100" itemScope itemType="https://schema.org/FAQPage">
        <h2 className="title-font text-2xl font-bold text-gray-900 mb-6">Frequently Asked Questions</h2>
        <dl className="space-y-5">
          {SCHEMA_ORG['@graph'][2].mainEntity.map(qa => (
            <div key={qa.name} itemScope itemType="https://schema.org/Question">
              <dt className="font-bold text-gray-900 mb-1" itemProp="name">{qa.name}</dt>
              <dd
                className="text-sm text-gray-600 leading-relaxed"
                itemScope
                itemType="https://schema.org/Answer"
                itemProp="acceptedAnswer"
              >
                <span itemProp="text">{qa.acceptedAnswer.text}</span>
              </dd>
            </div>
          ))}
        </dl>
      </section>

      {/* ── Trademark & Legal ── */}
      <section className="bg-white/70 rounded-3xl p-6 sm:p-8 mb-8 shadow-sm border border-orange-100">
        <h2 className="title-font text-2xl font-bold text-gray-900 mb-4">Legal &amp; Trademark</h2>
        <p className="text-sm text-gray-700 leading-relaxed mb-3">
          <strong>CoEater</strong>&#8482; is a trademark product of{' '}
          <strong>Ikash Private Limited</strong>, a company incorporated under the Companies Act, 2013.
          All rights in the CoEater name, logo, and associated intellectual property are owned exclusively
          by Ikash Private Limited.
        </p>
        <p className="text-sm text-gray-700 leading-relaxed mb-3">
          Unauthorised use, reproduction, or imitation of the CoEater trademark, brand identity, or any
          part of this platform — in whole or in part — is strictly prohibited and may result in legal
          action under applicable intellectual property laws.
        </p>
        <p className="text-sm text-gray-700 leading-relaxed mb-3">
          The CoEater platform, its software, design, content, and underlying technology are protected
          by copyright and other intellectual property rights vested in Ikash Private Limited.
          Any use beyond what is expressly permitted requires prior written consent from Ikash Private Limited.
        </p>
        <div className="mt-4 rounded-2xl bg-orange-50 border border-orange-200 px-5 py-4 text-xs text-gray-600 leading-relaxed">
          <p className="font-semibold text-gray-800 mb-1">&#169; {new Date().getFullYear()} Ikash Private Limited. All rights reserved.</p>
          <p>
            CoEater&#8482; is a trademark of Ikash Private Limited. Registered in India.
            For licensing, legal enquiries, or trademark-related matters, please contact us through
            the official CoEater platform.
          </p>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="text-center bg-gradient-to-r from-orange-500 to-red-500 rounded-3xl p-8 mb-8 text-white">
        <h2 className="title-font text-2xl font-bold mb-2">Ready to share your next meal?</h2>
        <p className="text-orange-100 mb-5 text-sm">
          Join thousands of food lovers who use CoEater to turn solo meals into shared experiences.
        </p>
        <a
          href="/"
          className="rounded-2xl bg-white text-orange-600 font-bold px-8 py-3 text-sm hover:bg-orange-50 transition shadow"
        >
          Get Started — It&rsquo;s Free
        </a>
      </section>

      {/* ── Footer ── */}
      <footer className="border-t border-gray-200 pt-6 pb-10 text-center">
        <p className="title-font font-bold text-gray-800 mb-1">CoEater&#8482;</p>
        <p className="text-xs text-gray-500 mb-1">A product of <strong className="text-gray-700">Ikash Private Limited</strong></p>
        <p className="text-xs text-gray-500 mb-4 max-w-sm mx-auto">
          Connecting people over food. Find a meal buddy in your city, today.
        </p>
        <div className="flex flex-wrap gap-3 justify-center mb-5" aria-label="Social media links">
          {SOCIAL_LINKS.map(link => (
            <a
              key={link.name}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={link.name}
              title={link.name}
              className="flex h-9 w-9 items-center justify-center rounded-full border border-orange-200 bg-white text-gray-600 hover:text-orange-600 hover:border-orange-400 transition"
            >
              <SocialIcon icon={link.icon} className="h-4 w-4" />
            </a>
          ))}
        </div>
        <nav className="flex flex-wrap gap-4 justify-center text-xs" aria-label="Footer navigation">
          <a href="/about" className="text-orange-600 font-semibold">About</a>
          <span className="text-gray-300">|</span>
          <a href="/privacy-policy" className="text-gray-600 hover:text-orange-600 font-medium transition">Privacy Policy</a>
          <span className="text-gray-300">|</span>
          <a href="/terms-of-use" className="text-gray-600 hover:text-orange-600 font-medium transition">Terms of Use</a>
          <span className="text-gray-300">|</span>
          <a href="/blogs" className="text-gray-600 hover:text-orange-600 font-medium transition">Blogs</a>
        </nav>
        <p className="text-xs text-gray-400 mt-4">
          &copy; {new Date().getFullYear()} Ikash Private Limited. CoEater&#8482; is a trademark of Ikash Private Limited. All rights reserved.
        </p>
      </footer>
    </article>
    </div>
  )
}
